module.exports = __webpack_public_path__ + "static/media/result-3.9b45e9ec.png";